import { Alert, Button, Result } from 'antd';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { moduleForPath, useVendorAccess } from 'src/hooks/use-vendor-access';

// Shows a "no access" page instead of a dashboard page the logged-in staff
// member hasn't been given (by module or by property).
function RequireAccess({ children }) {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { can, hasProperty } = useVendorAccess();
  const propertyId = searchParams.get('propertyId');

  const section = moduleForPath(pathname);
  const allowed =
    can(section) &&
    hasProperty(propertyId && propertyId !== 'null' ? propertyId : null);
  if (allowed && !can(section, 'manage'))
    return (
      <>
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="You have view-only access to this section, so changes won't be saved."
        />
        {children}
      </>
    );
  if (allowed) return children;

  return (
    <Result
      status="403"
      title="You don't have access to this page"
      subTitle="Ask the account owner to give you access if you need it."
      extra={
        <Link to="/dashboard/groups/groups-home">
          <Button type="primary">Back to home</Button>
        </Link>
      }
    />
  );
}

export default RequireAccess;
